import * as React from "react";
import { logoImageProps } from "../../shared/interface/LogoImageProps";

const LogoImage: React.FC<logoImageProps> = (props: logoImageProps) => {
  const { logoImage } = props;
  return (
    <React.Fragment>
      <img src={logoImage} alt="loadImg" />
    </React.Fragment>
  );
};

export default LogoImage;
